import { render, staticRenderFns } from "./ModalSelectRegion.vue?vue&type=template&id=3fd28b04&scoped=true"
import script from "./ModalSelectRegion.vue?vue&type=script&lang=js"
export * from "./ModalSelectRegion.vue?vue&type=script&lang=js"
import style0 from "./ModalSelectRegion.vue?vue&type=style&index=0&id=3fd28b04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd28b04",
  null
  
)

export default component.exports